module.exports = __webpack_public_path__ + "img/mai-bg.8eb45dab.png";